import { render } from "./MarqeeAlert.vue?vue&type=template&id=185155c3&ts=true"
import script from "./MarqeeAlert.vue?vue&type=script&lang=ts"
export * from "./MarqeeAlert.vue?vue&type=script&lang=ts"

import "./MarqeeAlert.vue?vue&type=style&index=0&id=185155c3&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__